{
  "en": {
    "task": {
      "actions": {
        "create": "Task",
        "create_and_send": "Create and send",
        "save_as_draft": "Save as draft",
        "update": "Edit task"
      },
      "attributes": {
        "assignments_count": "Assignments",
        "category": "Completion method",
        "created_at": "Created",
        "description": "Description",
        "title": "Title",
        "units": "Units"
      },
      "categories": {
        "confirmation": "Confirmation",
        "upload": "Document upload"
      },
      "categories_info": {
        "confirmation": "The assignee ticks the task off when it is done.",
        "upload": "The assignee has to upload a document to finish the task."
      },
      "labels": {
        "no_tasks": "No tasks for this project yet.",
        "required": "This field is required",
        "set_all_assignees": "Set the assignee | Set all {count} assignees",
        "still_to_do": "{count} still to do",
        "units_count": "{count} unit | {count} units",
        "units_required": "Select at least one unit"
      },
      "toasts": {
        "create": "Task created",
        "delete": "Task deleted",
        "update": "Task updated"
      }
    }
  }
}
